import { useLocation } from 'react-router';

import { getWebsiteOrigin } from 'src/utils/lib/env';

export const useMobilePageIframeSrc = () => {
  const location = useLocation();

  return `${getWebsiteOrigin()}/lp-mobile-a${location.search}`;
};
